module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rotate_CM.7e7f34cc.svg";